var _cfg = _config || {};

var cls = {
	log : function( _output ){
		if( app.debug ){
			console.log(_output);
		}
	}
};

var app = {
	debug: false,
	timeoutHandler: [],
	TWITTER: false,
	FACEBOOK: false,
	GPLUS: false,
	PINTEREST: false,
    affixHeaderHeight: 80,
	affixHeaderHeightMobile: 0
};

window.app = app || {};
app.modules || (app.modules = {});

app.modules.slider = function ($scope) {

	var slickOptions = {
		slidesToShow: 3,
		arrows: false,
		dots: true,
		responsive: [{
			breakpoint: 767,
			settings: {
				dots: true,
				arrows: false,
				slidesToShow:1,
				slidesToScroll:1
			}
		}]
	};

	$scope.find('.js-slider').each(function () {

		var $this = $(this);
		var options = $.extend({}, slickOptions);

		if ($this.data('slider-slide-count')) {
			options.slidesToShow = $this.data('slider-slide-count');
			options.slidesToScroll = $this.data('slider-slide-count');
		}

		if ($this.data('slider-slide-count-xs')) {
			options.responsive[0].settings.slidesToShow = $this.data('slider-slide-count-xs');
			options.responsive[0].settings.slidesToScroll = $this.data('slider-slide-count-xs');
		}

        if ($this.data('slider-slide-count-md')) {
            options.responsive.push({
                breakpoint: 1200,
				settings: {
					slidesToShow: $this.data('slider-slide-count-md'),
					slidesToScroll: $this.data('slider-slide-count-md')
                }
            });
        }

        if ($this.hasClass('slider-type-grid-product')) {
            options.responsive.push({
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            });
		}


		if ($this.data('slider-arrows')) {
			options.arrows = true;
			options.prevArrow = '<a class="slick-thumb-arrow slick-thumb-arrow--prev"><span class="icon icon-arrow_left"></span></a>';
			options.nextArrow = '<a class="slick-thumb-arrow slick-thumb-arrow--next"><span class="icon icon-arrow_right"></span></a>';
			options.responsive[0].settings.arrows = true;
		}

		$this.slick(options);
	});
};

app.modules.portalSlider = function ($scope) {

    var slickOptions = {
        slidesToShow: 1,
        arrows: false,
        dots: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow:1,
                slidesToScroll:1
            }
        }]
    };

    $scope.find('.js-portal-slider').each(function () {

        var $this = $(this);
        var options = $.extend({}, slickOptions);

        if ($this.data('slider-autoplay')) {
            options.autoplay = true;
            options.autoplaySpeed = $this.data('slider-autoplay');
        }

        $this.slick(options);
    });
};

app.modules.sliderThumbnav = function ($scope) {

	$scope.find('.js-sliderThumbnav').each(function () {

		var sliderMain =  $(this).find('.js-sliderThumbnav__main');
		var sliderThumbs =  $(this).find('.js-sliderThumbnav__thumbs');

		if (matchMedia('(max-width: 767px)').matches) {
			sliderThumbs = '';
		}

		sliderMain.not('.slick-initialized').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			fade: true,
			asNavFor: sliderThumbs,
			responsive: [{
				breakpoint: 768,
				settings: {
					dots: true,
                    arrows: true,
                    prevArrow: '<a class="slick-thumb-arrow slick-thumb-arrow--prev"><span class="icon icon-arrow_left"></span></a>',
                    nextArrow: '<a class="slick-thumb-arrow slick-thumb-arrow--next"><span class="icon icon-arrow_right"></span></a>'
                }
			}]
		});

		if (matchMedia('(min-width: 768px)').matches) {

			sliderThumbs.slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				asNavFor: sliderMain,
				dots: false,
				centerMode: false,
				infinite: true,
				arrows: true,
				prevArrow: '<a class="slick-thumb-arrow slick-thumb-arrow--prev"><span class="icon icon-arrow_left"></span></a>',
				nextArrow: '<a class="slick-thumb-arrow slick-thumb-arrow--next"><span class="icon icon-arrow_right"></span></a>',
				focusOnSelect: true
			});
		}
	});
};

app.modules.lightbox = function ($scope) {
	$.loadScript("/static/js/libs/magnific-popup.js").done(function () {

		var lightboxes = $scope.find('.js-lightbox'),
			imgLightboxes = lightboxes.not('.js-lightbox--iframe'),
			iframeLightbox = lightboxes.filter('.js-lightbox--iframe');

		imgLightboxes.magnificPopup(app.modules.lightbox.defaultOptions);

		iframeLightbox.magnificPopup(
			$.extend(true, {}, app.modules.lightbox.defaultOptions, {
				type: 'iframe'
			})
		);

	}).fail(function () {
		console.error('magnific popup loading error');
	});
};

// app.modules.scrollTo = function ($scope) {
//     function scrollPosition (_this){
//         var target = _this.attr('href');
//
//         $('html,body').animate({
//             scrollTop: $(target).offset().top
//         },500);
//     }
//     $scope.find('.js-scroll-to').on('click', function (e) {
//         scrollPosition($(this));
//     });
// };


app.modules.lightbox.defaultOptions = {
	type: 'image',
	closeOnContentClick: false,
	closeBtnInside: false,
	disableOn: 767,
	mainClass: 'mfp-with-zoom mfp-img-mobile'

	,image: {
		verticalFit: true,
		titleSrc: function(item) {
			var $titleElement = $(item.el).find('.js-lighbox__title');
			if ($titleElement && $titleElement.length) {
				return $titleElement.html();
			}

			return '';
		}
	}
	,gallery: {
		enabled: true,
		arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="icon icon-arrow_%dir%"></span></button>',
		tCounter: ''
	}
	,callbacks: {

	}
	,retina: {
		ratio: 1,
		replaceSrc: function(item, ratio) {
			return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
		}
	}
};

app.modules.lightboxGallery = function ($scope) {

	if (matchMedia('(max-width: 767px)').matches) {
		$('body').on('tap', '.js-lightbox-gallery__item', function(evt){
			evt.preventDefault();
		});
	}

	$.getScript("/static/js/libs/jquery.magnific-popup.min.js").done(function () {
		$scope.find('.js-lightbox-gallery').each(function () {
			$(this).find('.js-lightbox-gallery__item').magnificPopup(app.modules.lightbox.defaultOptions);
		});
	});
};

app.modules.videoLightbox = function ($scope) {
	if (matchMedia('(max-width: 767px)').matches) {
		return;
	}

	var iframeOptions = $.extend(true, {}, app.modules.lightbox.defaultOptions, {
		type: 'iframe'
	});
	var inlineOptions = $.extend(true, {}, app.modules.lightbox.defaultOptions, {
		type:'inline'
	});

	$.loadScript("/static/js/libs/magnific-popup.js").done(function () {
		$scope.find('.js-video-lightbox').each(function () {
			var $this = $(this);

			if ($this.hasClass('js-video-lightbox--asset')) {
				$(this).magnificPopup(inlineOptions);

				$this.on('mfpOpen', function(evt, a,b,c) {
					var $video = $($.magnificPopup.instance.container).find('video');
					$video[0].play();
				});
			} else {
				$(this).magnificPopup(iframeOptions);
			}

		});
	});
};

app.modules.video = function ($scope) {

	if (matchMedia('(max-width: 767px)').matches) {
		return;
	}

	app.modules.video.id || (app.modules.video.id = 1);
	$.getScript('/static/js/libs/video.js').done(function (){
		$scope.find('.video-js').each(function () {
			var id = $(this).prop('id');
			if (!id) {
				id = 'video-js-id-' + app.modules.video.id++;
				$(this).prop('id', id);
			}            videojs(id);
		});
	}).fail(function () {
		console.error('video.js loading error');
	});
};

app.modules.parsley = function ($scope) {
    if (_cfg.lang && _cfg.lang !== 'en') {
        $.loadScript("/static/js/libs/i18n/parsley/" + _cfg.lang + ".js").done(function () {
            init();
        }).fail(function () {
			init();
        });
    } else {
    	init();
	}

    function init() {
        var parsleyElements = $scope.find('.js-parsley');

        var parsleyOptions = {
			successClass: 'has-success',
			errorClass: 'has-error',
			classHandler : function( _el ){
				return _el.$element.closest('.form-group, .js-form-group');
			},
			errorsContainer: function (_el) {
				var errorContainer = _el.$element.closest('.form-group').find('.form-errors, .js-form-errors');
				if (errorContainer && errorContainer.length > 0) {
					return errorContainer;
				}
			}
		};

		parsleyElements.each( function(){
            var $form = $(this);

            $form.parsley( parsleyOptions );
            $form.parsley().on('field:error', function() {
                var parsleyId = this.__id__;
                var fieldClass = this.__class__;

                if (fieldClass == 'ParsleyFieldMultiple') {
                    parsleyId = 'multiple-' + this.$element.data('parsley-multiple');
                }

                this.$element.attr({
                    'aria-invalid': "true",
                    'aria-describedby': 'parsley-id-'+ parsleyId
                });
            });
            $form.parsley().on('field:success', function() {
                this.$element.removeAttr('aria-invalid aria-describedby');
            });


            if($(this).hasClass('js-send-virtual-pageview')){

                var url = location.pathname;
                if($(this).data('pageview-url')) {
                    url = $(this).data('pageview-url');
                }

                console.log('virtual location:', url);

                $(this).parsley().on('form:validate', function (formInstance) {
                    var isValid = formInstance.isValid();

                    if(isValid){
                        if (typeof ga !== 'undefined') {
                            console.log(url);
                            ga('send', 'pageview', url + '-success');
                        }
                    } else{
                        console.log('not valid');
                    }
                });
            }

        });

    }

};

app.modules.datepicker = function($scope) {

	/*
	window.Parsley.addValidator('dateformat',
		function (value) {
			return /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19|20)\d\d$/.test(value);
		}, 32).addMessage('en', 'dateformat', 'Bitte geben Sie ein gültiges Datumsformat ein (dd.mm.yyyy)');
*/
	$.getScript("/static/js/libs/bootstrap-datepicker.min.js").done(function () {
		$.getScript("/static/js/libs/bootstrap-datepicker.de.js").done(function () {
			$('.has-datepicker').datepicker({
				format: 'dd.mm.yyyy',
				autoclose: true,
				weekStart: 1,
				language: 'de'
			});

			$('.input-daterange').datepicker({
				format: 'dd.mm.yyyy',
				daysOfWeekDisabled: '0',
				weekStart: 1,
				language: 'de',
				startDate: 'today'

			});
		});
	});
};

app.tabsCollapse = function () {

	$.ajax({
		url: "/static/js/libs/bootstrap-tabcollapse.js",
		dataType: "script",
		cache: true
	}).done(function() {
		$('body').find('.js-tabs-collapse').each(function(i, el){
			$(this).tabCollapse();
		});

	});
	
};

app.modules.parsley.options = {
	// successClass: 'has-success',
	// errorClass: 'has-error',
	// classHandler: function (_el) {
	// 	return _el.$element.closest('.form-group');
	// },
	// errorsContainer: function (_el) {
	// 	var errorContainer = _el.$element.closest('.form-group').find('.form-errors');
    //
	// 	if (errorContainer && errorContainer.length > 0) {
	// 		return errorContainer;
	// 	}
	// }
};

app.modules.dropdown = function($scope) {

	if (_cfg.openShopNav) {
        var $shopNav = $scope.find('.js-open-shop-nav');
        if ($shopNav.length) {
			$shopNav.addClass('is-open');
			$('body').on('click', closeDropdown);
        }
	}

	$scope.find('.js-dropdown > .btn').on('tap', function(evt){

		var parent = $(this).closest('.js-dropdown');
		if(parent.hasClass('is-open')){
			parent.removeClass('is-open');
			evt.preventDefault();
		} else {
			parent.addClass('is-open');
            $('body').on('click', closeDropdown);
		}

	});

	function closeDropdown (evt) {

		if ($(evt.target).closest('.js-dropdown.is-open').length < 1) {

			var jsDropdown = $('.js-dropdown');

			jsDropdown.removeClass('is-open');
			jsDropdown.find('ul li ul').css('display', 'none');

            $('body').off('click', closeDropdown);
		}
	}

};

app.stickyNav = function () {
	if(matchMedia('(max-width: 991px)').matches) {
		/*don't init on mobile or if the page is scaled down*/
		return;
	}

	$('.js-affix-header').affix({
		offset: {
			top: 114
		}
	});
};

app.touchNav = function () {
    if (matchMedia('(min-width: 768px)').matches) {
        var mainNavItems = $('.js-touch-nav>li'),
            mainNavLinks = $('.js-touch-nav>li>a'),
            mainNavItemsSub = $('.js-touch-nav__open-subnav-wrapper > li'),
            mainNavLinksSub = $('.js-touch-nav__main-item'),
            dropdownClass = '.js-touch-nav__dropdown';

        mainNavLinks.on('click', function (evt) {
            // this is for desktop AND tablet
            var parent = $(this).parent();

                if (!parent.hasClass('is-open')) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    mainNavItems.removeClass('is-open');
                    parent.addClass('is-open');

                    $('body').on('click touchstart', bodyClickHandler);
                }
        });

        // only tablet
        mainNavLinksSub.on('touchend', function (evt) {
            if (window.TouchEvent && evt.originalEvent instanceof TouchEvent) {
                var parent = $(this).parent();
                var $this = $(this);

                if (!parent.hasClass('is-open') && $this.hasClass('js-touch-nav__open-subnav')) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();

                    if ($this.hasClass('js-touch-nav__open-subnav')) {
                        mainNavItemsSub.removeClass('is-open');
                        mainNavItemsSub.closest(dropdownClass).removeClass('has-open-subnav');

                        parent.addClass('is-open');
                        $this.closest(dropdownClass).addClass('has-open-subnav');
                    } else {
                        mainNavItemsSub.removeClass('is-open');
                        mainNavItemsSub.closest(dropdownClass).removeClass('has-open-subnav');
                    }
                }
            }
        });

        // desktop
        mainNavLinksSub.on('mouseover', function (evt) {
            var parent = $(this).parent();
            var $this = $(this);

            if ($this.hasClass('js-touch-nav__open-subnav')) {
                mainNavItemsSub.removeClass('is-open');
                mainNavItemsSub.closest(dropdownClass).removeClass('has-open-subnav');

                parent.addClass('is-open');
                $this.closest(dropdownClass).addClass('has-open-subnav');
            } else {
                mainNavItemsSub.removeClass('is-open');
                mainNavItemsSub.closest(dropdownClass).removeClass('has-open-subnav');
            }
        });

        mainNavLinks.on('keydown', function(evt) {
            if(evt.keyCode == 40 || evt.keyCode == 38 || evt.keyCode == 32){
                evt.preventDefault();
                $(this).parent().addClass('is-open');
                $('body').on('keyup', escKeyHandler);
            } else if (evt.keyCode == 9 && !$(this).parent().hasClass('is-open')) {
                mainNavItems.removeClass('is-open');
                $('body').off('keyup', escKeyHandler);
            }
        });

        $('.js-toggle-nav-level').on('click', function (evt) {
            evt.preventDefault();
            var navItem = $(this).closest('li');

            if(!navItem.hasClass('is-open')) {
                navItem.closest('ul').find('li').removeClass('is-open');
                navItem.addClass('is-open');
                $('body').on('click', bodyClickHandler);
            } else {
                navItem.removeClass('is-open');
                $('body').off('click', bodyClickHandler);
            }
        });

        function escKeyHandler (evt){
            if(evt.keyCode == 27){
                mainNavItems.removeClass('is-open');
                $('body').off('keyup', escKeyHandler);
            }
        }

        function bodyClickHandler (evt) {
            if ($(evt.target).parents('.js-touch-nav').length < 1) {
                evt.preventDefault();
                $('.navbar-main').find('li').removeClass('is-open');

                // also close subitems
                mainNavItemsSub.removeClass('is-open');
                mainNavItemsSub.closest(dropdownClass).removeClass('has-open-subnav');

                $('body').off('click touchstart', bodyClickHandler);
            }
        }
    }

};

app.mobileMainNav = function () {

	if (matchMedia('(max-width: 767px)').matches) {

		var xsMainOff = parseInt($('.navbar-brand').innerHeight());
		$('#nav-main').css({ top : xsMainOff });

		var body = $('body');

		body.on('click', '#btn-showMobileNav', function(evt){
			$('.btn-group--xs-search-nav').addClass('fadeOutRight');
			$('#btn-close-xs-mainnav').show().removeClass('fadeOutLeft').addClass('fadeInLeft');
			$('#nav-main').addClass('is-open');
            $('html').addClass('is-scrolling-disabled');
			evt.preventDefault();
		});
		body.on('click', '#btn-close-xs-mainnav', function(evt){
			$('.btn-group--xs-search-nav').removeClass('fadeOutRight').addClass('fadeInRight');
			$('#btn-close-xs-mainnav').removeClass('fadeInLeft').addClass('fadeOutLeft');
			$('#nav-main').removeClass('is-open');
            $('html').removeClass('is-scrolling-disabled');

			evt.preventDefault();
		});
		
        body.find('.js-toggle-subnav').on('click', function (evt) {
            evt.preventDefault();
            var navbar = $(this).closest('.js-toggle-subnav__container'),
                navbarCollapse = $(this).closest('.navbar-collapse'),
                navItem = $(this).closest('.js-toggle-subnav__li');

            if (!navItem.hasClass('is-open')) {
                navbar.children('.js-toggle-subnav__li').removeClass('is-open');
                navItem.addClass('is-open');
                navbarCollapse.addClass('has-open-subnav');
            } else {
                navItem.removeClass('is-open');
                navbarCollapse.removeClass('has-open-subnav');
            }
        });

	}
};

app.menuToggler = function() {

	if (matchMedia('(max-width: 767px)').matches) {

		$('body').on('tap','.dropdown-menu .icon--menu-collapse', function(evt){
            evt.preventDefault();
			var parentLi = $(this).closest('li');
			var parentLiSiblings = parentLi.siblings('li');

			if(!parentLi.hasClass('is-open')){
				parentLi.addClass('is-open');
				parentLiSiblings.removeClass('is-open');
			} else {
				parentLi.removeClass('is-open');
			}

		});

	}

	if (matchMedia('(min-width: 768px)').matches) {

		$('body').on('tap','.dropdown-menu li.has-dropdown > a', function(evt){

			if (window.TouchEvent && evt.originalEvent instanceof TouchEvent) {
				var parentLi = $(this).closest('li');
				var parentLiSiblings = parentLi.siblings('li');

				if(!parentLi.hasClass('is-open')){
					parentLi.addClass('is-open');
					parentLiSiblings.removeClass('is-open');
				} else {
					window.location.href = $(this).attr('href');
				}

				evt.preventDefault();
			}

		});
	}
};

app.modules.lagerhausLocationSelect = function($scope) {
	$.loadScript('/static/js/libs/location-dropdown.js').done(function () {
		locationDropdown.init($scope);
	});
};

app.productGridInit = function(){
	 $.loadScript('/static/js/libs/productgrid.js').done(function () {
		productgrid.init();
	});
};


app.pdNumberSpinner = function() {

	var body = $('body');

	body.on('tap','.js-number-spinner__down', function (evt) {
		countDown(evt, $(this));
	});

	body.on('tap','.js-number-spinner__up', function (evt) {
		countUp(evt, $(this));
	});
	/*---*/

	body.on('change','.js-number-spinner__input', function(evt) {
		var $input = $(this);
		var value = Number($input.val());

		if(isNaN(value)) {
			value = 1;
		}

		$input.val(Math.max(value,1));
        // destroy popover for scale-prices
        body.find('.js-scale-prices-popover').popover('destroy');
	});

	function countUp(evt,_this){
		var input = _this.closest('.js-number-spinner').find('.js-number-spinner__input');
		input.val(+input.val()+1);
		input.trigger('change');
		evt.preventDefault();
	}

	function countDown(evt, _this){
		var input = _this.closest('.js-number-spinner').find('.js-number-spinner__input');
		input.val(Math.max(+input.val()-1, 1));
		input.trigger('change');
		evt.preventDefault();
	}

};

app.pdSelectCCLocation = function() {

	var ddSelektor = $('.js-dropwdown-select-cc-location').find('.dropdown-menu > li > a');
	ddSelektor.on('tap', function(evt){

		var string = $(this).html();
		var ccLocation = $(this).data('location');

		$('#string-replace').html(string);
		$('#cart-filiale').attr('value', ccLocation);

		$('.js-dropwdown-select-cc-location').removeClass('open');

		evt.preventDefault();
	});
	
};

app.modules.rangeSlider = function() {
	$.loadScript('/static/js/libs/productgrid.js').done(function () {
		productgrid.initRangeSlider();
	});
};

app.isClickable = function () {

    $('body').on('click', '.js-go-to-link, .isClickable', function (evt) {
        var $target = $(evt.target);

        if($target.hasClass('isClickable__ignore') || $target.parent().hasClass('isClickable__ignore')) {
            return;
        }
        
        if (!$target.is('a, button, input, select, textarea, label')
            && !$target.closest('a, button, input, select, textarea, label').length) 
        {
            var link = $(this).find('.js-go-to-link__link:first');
            if (!link.length) {
                link = $(this).find('a:first');
            }
            var href = link.attr('href');

            if (window.getSelection().toString()) {
                // make links selectable - so do nothing if a selection was made
                evt.preventDefault();
                evt.stopImmediatePropagation();
            } else if (href) {

                if (link[0]) {
                    try {
                        link[0].dispatchEvent(new MouseEvent(evt.originalEvent.type, evt.originalEvent));

                        // allow crtl + click on the whole .js-go-to-link element.
                        // this works only for some browsers (eg: Chrome, Edge)
                        // but does not break anything for others (eg: IE, Firefox)
                    } catch (e) { // IE 11 fallback
                        link[0].click();
                    }
                }

                evt.preventDefault();
                evt.stopImmediatePropagation();
            }
        }
    });

};

app.modules.ajaxInclude = (function () {
	
	function ajaxIncludeCallback() {
		var includedContainer = $(this).next();

		if ($(this).is('[data-target]')) {
			var targetContainer = $($(this).data('target'));
			if (targetContainer.length > 0) {
				includedContainer = targetContainer;
			}
		}

		app.initModules(includedContainer);
		$(this).off('ajaxInclude', ajaxIncludeCallback);

		if (_config && _config['debug']) {
			includedContainer.css('outline', '3px solid red');
			console.warn('ajax included: ', includedContainer);
		}
	}

	return function ($scope) {
		var ajaxIncludeElements = $scope.find('.js-ajaxInclude');

		ajaxIncludeElements.on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude({
			device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
		});

		ajaxIncludeElements.filter('[data-interaction=click]').on('tap', function () {
			$(this).removeAttr('data-interaction');
			$(this).extendAjaxInclude({
				device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
			});
		});

		ajaxIncludeElements.filter('[data-interaction=submit]').on('submit', function (evt) {
			evt.preventDefault();
			$(this).removeAttr('data-interaction');
			$(this).extendAjaxInclude({
				device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
			});
		});
	};
}());

app.modules.openOpeningTimes = function ($scope) {

    $scope.find('.open--opening-times').on('click', function(ev) {
        ev.preventDefault();
        var openingTimesWrapper = $(this).parent('.opening-times-wrapper');

        //todo fadein
        openingTimesWrapper.find('.opening-times-table').removeClass('hidden');
        $(this).find('.icon.icon-plus').addClass('hidden');
    });

	/*
	 //close after being opened?
	 $scope.find('.location-result-opening-times').on('click', function(ev) {
	 ev.preventDefault();
	 $(this).prev('.open--opening-times').removeClass('hidden');
	 $(this).addClass('hidden');
	 });*/


};


app.initLocatorInTab = function(){
    $('.js-init-storelocator').one('shown.bs.tab', function (e) {
        if( matchMedia('(min-width:768px)').matches ) {
            app.storelocator();
        }
    });
};

app.modules.locationSearch = function() {
	$.loadScript('/static/js/libs/location-search.js').done(function () {
		locationSearch.init();
	});
};

app.contactFormLocationSuggest = function() {
	$.loadScript('/static/js/libs/location-search.js').done(function () {
		locationSearch.initFormSuggest();
	});
};

app.storelocator = function($scope) {
	$.loadScript('/static/js/libs/store-locator-init.js').done(function () {
		lagerhausStoreLocator.init($scope);
	});
};

app.modules.tooltips = function($scope) {
	$('.tooltip-holder').tooltip();
};

app.accountDropdown = function($scope) {

	if( matchMedia('(min-width:768px)').matches ) {


        window.addEventListener("load", function(evt){
            var autoOpenElement = $('.has-account-settings .account-item[data-auto-open="1"]');

            if(autoOpenElement.length) {
            	openAccountWindow(autoOpenElement, evt);

            	window.setTimeout(function() {
            		closeAccountWindow(evt);
				}, 5000);
			}
        });

		var openAccountWindow = function(element, evt) {
            var $this = element;
            var $thisLi = $this.closest('li');
            var $thisSiblings = $thisLi.siblings('li');

            /* return if open */
            if($thisLi.hasClass('active')){
                $thisLi.removeClass('active');
                closeAccountWindow(evt);
                evt.stopImmediatePropagation();
                return;
            } else {
                $thisSiblings.removeClass('active');
                $this.addClass('is-active');
                $thisLi.addClass('active');
            }

            /* check offset-left of a element */
            var eleOffLeft = $this.position().left;
            var eleWidth = $this.width();
            var arrowPos = parseInt(eleOffLeft + (eleWidth/2));

            $.ajax({
                url: $this.attr('data-url'),
                method : 'post'
            }).done(function (data) {

                $('#user-flyout').show().prepend(data);

                /* check nav-width */
                var navUserConsole = $('#nav--user-console');
                var usWidth = navUserConsole.width();
                var flyoutDropdown = navUserConsole.find('.dropdown-menu').first();
                app.initModules(flyoutDropdown);

                // flyoutDropdown.css({ 'width' : usWidth });
                $('#user-flyout__arrow').css({ 'left' : arrowPos });

                $('body').on('click', closeAccountWindow);
            });
		};

		var closeAccountWindow = function(evt) {

            if ( $(evt.target).closest('.account-dropdown').length < 1 && !$(evt.target).hasClass('account-dropdown') ) {

                var userFlyOut = $('#user-flyout');

                userFlyOut.find('.dropdown-menu').remove();
                userFlyOut.hide();
                $('body').off('click', closeAccountWindow);
                evt.preventDefault();

                if ( $(evt.target).closest('.account-item').length < 1 ) {
                    $('#nav--user-console').find('li.active').removeClass('active');
                }
            }
        };

		$('.has-account-settings .account-item').on('click', function(evt) {
			evt.preventDefault();
			openAccountWindow($(this), evt);
		});
	}
};

app.modules.ajaxForm = function($scope) {
	$scope.find('form.ajax-form').submit(function (e) {
        e.preventDefault();

		// init
		var form = $(this);
		var target = $(form.data('target'));
		var inputs = form.find('input, button');
		var data = form.serialize();
		var method = form.prop('method');


		form.addClass('is-laoding');
		// validate form
		if(form.hasClass('js-parsley')){
			if(!form.parsley().isValid()){
				return false;
			}
		}

		// prevent form from sending the request twice (since parsley fires a second submission)
		if (!form.data('requestSent')){
			inputs.prop('disabled', true);

			// execute request
			$.ajax({
				url: form.prop('action')
				, method: method
				, data: data

			}).done(function (response) {

				inputs.prop('disabled', false);

				var html = $(response);

				target.replaceWith(html);
				app.initModules(html);
				form.trigger('submitted');
				$('.update-nr').trigger('update-cart-nr');
				form.removeClass('is-laoding');

			});
			form.data('requestSent', true);
		}
	});
};

app.modules.fuelForm = function ($scope) {
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    if (matchMedia('(min-width: 768px)').matches) {
        var maxFuelboxHeight = 0;
        $('.js-fuel-box__list').each(function() {
            if ($(this).outerHeight() > maxFuelboxHeight) {
                maxFuelboxHeight = $(this).outerHeight();
            }
        }).height(maxFuelboxHeight);
    }

	$scope.find('.js-fuel-form__input').bind('input', debounce(function () {
		var form = $(this).closest('.js-fuel-form'),
            $fuelBox = $scope.find('.js-fuel-box'),
			$target = $($(form).data('target')),
			url = $(form).data('url'),
            $formBtn = form.find('button[type=submit]');

		form.parsley().validate();

        if(!form.parsley().isValid()){
            //console.log('not valid');
            $formBtn.attr('disabled','disabled');
        } else {
            $formBtn.attr('disabled',false);
            var formData = form.serialize();
            $fuelBox.addClass('is-loading');

            $.ajax(url, {
                data: formData,
                cache: false,
                dataType: 'html',
				method: 'post',
                headers: {ajax: true}
            }).done(function (data) {
                $target.html(data);
                var $fuelBoxActive = $scope.find('.js-fuel-box.fuel-box--active');
                var calculatedPrice = $fuelBoxActive.find('.js-fuel-form__total-price-calculated').text();
                $('.js-fuel-form__total-price-placeholder').html(calculatedPrice);

                app.initModules($target);

                $fuelBox.removeClass('is-loading');
            });
        }
	}, 200));


    $scope.find('.js-fuel-box').on('click', function () {
        var id = $(this).attr('data-id');
        var $this = $(this);
        var $price = $this.closest('.js-fuel-form-body').find('.js-fuel-form__total-price-placeholder');
        var $select = $this.closest('.js-fuel-form-body').find('.js-fuel-box__input');
        var $selectedOption = $this.closest('.js-fuel-form-body').find('.js-fuel-box__input option[data-id='+id+']');

        $('.js-fuel-box').removeClass('fuel-box--active');
        $this.addClass('fuel-box--active');

        var calculatedPrice = $this.find('.js-fuel-form__total-price-calculated').text();

        $price.text(calculatedPrice);

        $select.find('option').attr('selected',false);
        $selectedOption.prop('selected',true);
    });

    /*$scope.find('.js-fuel-box__input').on('change', function () {
        console.log('change');
        var id = $(this).find(':selected').attr('data-id')
        var $fuelBox = $scope.find(".js-fuel-box[data-id="+id+"]");
        var $price = $scope.find('.js-fuel-form__total-price-placeholder');
        var calculatedPrice = $fuelBox.find('.js-fuel-form__total-price-calculated').text();

        $scope.find('.js-fuel-box').removeClass('fuel-box--active');
        $price.text(calculatedPrice);
        $fuelBox.addClass('fuel-box--active');
    });*/
};

app.modules.checkVoucher = function ($scope) {
    $scope.find('.js-voucher__check').on('click', function (evt) {
        evt.preventDefault();

        var $this = $(this),
            container = $this.closest('.js-voucher'),
            input = container.find('.js-voucher__input'),
            modal = $($this.data('target')),
            url = $this.data('url');

        input.parsley().validate();

        if (input.parsley().isValid()) {
            $.ajax(url, {
                data: {
                    'voucher-token' : input.val()
                },
                cache: false,
                dataType: 'html',
                headers: {ajax: true}
            }).done(function (data, status, xhr) {
                var ct = xhr.getResponseHeader("content-type") || "";

                if (ct.indexOf('json') > -1) {
                    location.reload();
                } else {
                    modal.html(data);
                    modal.modal('show');
				}
            });
        }
    });
};

app.ajaxAddToWishList = function ($scope) {
	$.loadScript('/static/js/libs/cart.js').done(function () {
		cart.initAddToWishlist();
	});
};

app.ajaxAddToCart = function () {
	$.loadScript('/static/js/libs/cart.js').done(function () {
		cart.initAddToCart();
	});
};

app.updateCartNr = function($scope) {
	$.loadScript('/static/js/libs/cart.js').done(function () {
		cart.initUpdateCartNr();
	});
};

app.stickyHeader = function() {

	if (matchMedia('(max-width: 767px)').matches) {
		return;
	}

	var lastScrollTop = 0,
		$header = $('#header-main'),
		$body = $('body'),
		$headerBreakpoint = $header.height();

	$(window).scroll(function(event){

		var st = $(this).scrollTop();

		if (st > lastScrollTop){

			// scroll down
			if(st > $headerBreakpoint && $header.hasClass('is-fixed') ) {
				$header.removeClass('is-fixed');
				$body.css({ 'padding-top' : 0 });
			}

		} else {

			// scroll up
			headerOnTopAgain();

			if(st > $headerBreakpoint && !$header.hasClass('is-fixed') ) {
				$header.addClass('is-fixed');
				$body.css({ 'padding-top' : $headerBreakpoint });
			}
		}

		/* remove class when on top again */
		function headerOnTopAgain (){
			if ( st == 0 && $header.hasClass('is-fixed') ){
				$header.removeClass('is-fixed');
				$body.css({ 'padding-top' : 0 });
			}
		}

		lastScrollTop = st;
	});

};


app.modules.actionChanger = function ($scope) {
    $scope.find('.js-action-changer').on('submit', function () {
        var newAction = $(this).data('action');

        if (newAction) {
            $(this).attr('action', newAction);
        } else {
            $(this).attr('action', '');
        }
    });
};

app.modules.showInfoFields = function($scope) {

	$scope.find(".toggle-textbox").on('click', function() {
		$scope.find('.checkout-contact-info-field').addClass('hidden');

		$(this).children("input[type='text']").removeClass('hidden');
	});
};

app.modules.chooseLocationCart = function($scope) {

	$scope.find('.cart-choose-location, .btn-cart-choose-location').on('click', function() {
		$.ajax({
			url: '/warenkorb/change-location',
			data: {
				'location-id': $(this).data('location-id'),
                'alert-change-location': 1
			}
		}).done(function (result) {
			location.reload();

            var topOffset;
            if (matchMedia('(max-width:767px)').matches) {
                topOffset = app.affixHeaderHeightMobile || 0;
            } else {
                topOffset = app.affixHeaderHeight || 0;
            }
            window.scrollTo(window.scrollX, $('#cart-wrapper').offset().top - topOffset - 20);
		});
	});
};

app.modules.preventCollapseClose = function ($scope) {
	$scope.find('.js-prevent-collapse-close').on('click', function (e) {
		if(!$(this).hasClass('collapsed')) {
			e.stopImmediatePropagation();
		}
	})
};

app.socialLinks = function() {
	$('.social-icon--facebook').on('click', function() {
		window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(location.href),'facebook-share-dialog','width=626,height=436');
		return false;
	});

	$('.social-icon--googleplus').on('click', function() {
		window.open('https://plus.google.com/share?url='+encodeURIComponent(location.href),'',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
		return false;
	});

	$('.social-icon--twitter').on('click', function() {
		window.open('https://twitter.com/intent/tweet?url='+encodeURIComponent(location.href),'','width=626,height=436');
		return false;
	});
};

app.chart = function() {
	$.getScript("/static/js/libs/fuel-chart.js").done(function () {
		fuelChart.init();
	});
};

app.houseConfigurator = function() {
	$.getScript("/static/js/libs/houseconfigurator.js").done(function () {
		houseConfigurator.init();
	});
};

app.modules.houseConfigSlider = function ($scope) {
	app.modules.houseConfigSlider.elementId || (app.modules.houseConfigSlider.elementId = 0);
	$.loadScript('/static/js/min/060-slick.min.js').done(function(){
		var defaultMainSlickOptions = {
			speed: 350,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						arrows: false,
					}
				}
			]
		};
		var defaultThumbSlickOptions = {
			speed: 200,
			arrows: false,
			slidesToShow: 7,
			slidesToScroll: 7,
			focusOnSelect: true,
			dots: true,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5
					}
				}
				,{
					breakpoint: 767,
					settings: {
						arrows: true,
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
			]
		};

		$scope.find('.js-house-slider').each(function () {
			var mainSlickOptions = $.extend({}, defaultMainSlickOptions);
			var $mainSlider = $(this).find('.js-house-slider__main');

			var $thumbSlider = $(this).find('.js-house-slider__thumbs');

			app.modules.houseConfigSlider.elementId++;
			var mainId = 'house-slider-main-' + app.modules.houseConfigSlider.elementId;
			var thumbId = 'house-slider-thumb-' + app.modules.houseConfigSlider.elementId;

			$mainSlider.attr('id', mainId);
			$thumbSlider.attr('id', thumbId);

			mainSlickOptions.asNavFor =  '#' + thumbId;

			$thumbSlider.slick($.extend({}, defaultThumbSlickOptions, {
				asNavFor: '#' + mainId
			}));

			$mainSlider.slick(mainSlickOptions);
		});
	});
};

app.modules.toggleProductFilter = function ($scope) {
    var filterContent = $scope.find('.js-filter-content');
    $scope.find('.js-toggle-filter').on('tap', function (e) {

        if(filterContent.hasClass('is-open')){
            filterContent.slideUp(400);
            filterContent.removeClass('is-open');
            $(this).removeClass('is-open');
            $scope.find('.btn-filter').removeClass('is-open');
        }else{
            filterContent.slideDown(400);
            filterContent.addClass('is-open');
            $(this).addClass('is-open');
            $scope.find('.btn-filter').addClass('is-open');
        }

    });
};

app.modules.showHousePlans = function ($scope) {
	$scope.find('.js-show-plan').on('tap', function (evt) {
		evt.preventDefault();
		var planSrc = $(this).data('plan-img-src'),
			house = $(this).closest('.house');

		house.find('.house__plan').addClass('is-active');
		house.find('.js-plan-img').attr('src', planSrc);
	});
	$scope.find('.js-close-plan').on('tap', function (evt) {
		evt.preventDefault();
		$(this).closest('.house__plan').removeClass('is-active');
	});
};


app.modules.scrollTo = (function () {
    return function ($scope) {
		$scope.find('.js-scroll-to').on('click', function (evt) {
			evt.preventDefault();
			var targetSelector = $(this).data('scroll-target') || $(this).attr('href');
			var $target = $(targetSelector);

            app.modules.scrollTo.scrollToEl($target);
		});
	};
}());

app.modules.scrollTo.scrollToEl = function scrollTo ($target, callback) {
    console.log('scrolling');
    if (!$target || !$target.length) {
        console.warn("Can't scroll to '" + target + "'. Target element not found");
        return;
    }

    var duration = Math.abs($target.offset().top - window.scrollY) / 8 + 100;

    var topOffset;
    if (matchMedia('(max-width:767px)').matches) {
        topOffset = app.affixHeaderHeightMobile || 0;
    } else {
        topOffset = app.affixHeaderHeight || 0;
    }
    $('html, body').stop().animate({
            scrollTop: $target.offset().top - topOffset - 30
        },
        duration,
        'swing', function () {
            if (callback) {
                callback();
            }
        }
    );
};

app.modules.fileUpload = function () {

	var uploading_file = null;
	var valid_file = null;

	function initDeleteUpload() {

		$('.delete-upload').on('tap', function (e) {
			$(this).closest('.upload-image-item').find('input').val('');
			$(this).hide();
		});
	}

	$('.js-upload-btn').change(function(e){

		var uploadItem =  $(this).closest('.upload-image-item');

		uploading_file = $(this).val();

		var allowedExtensions = $(this).data('allowed-extensions');
		if(!allowedExtensions) {
            allowedExtensions = '\.jpg|\.png|\.jpeg';
        }
		valid_file = new RegExp(allowedExtensions, 'g').test(uploading_file.toLowerCase());

		if(valid_file){
			uploadItem.removeClass('has-error');
			uploadItem.find('.upload-input').val(uploading_file);
			uploadItem.find('.delete-upload').show();

			initDeleteUpload();
		} else{
			uploadItem.addClass('has-error');
		}
	});
};

app.menuAim = function() {

	$.getScript("/static/js/libs/online-shop-menu.js").done(function () {
		onlineShopMenu.init();
	});
};

app.RentMachines = function() {
	$.getScript("/static/js/libs/rent-machines.js").done(function () {
		rentMachines.init();
	});
};

app.liveSearch = function() {
	$.getScript("/static/js/libs/live-search.js").done(function () {
		if (matchMedia('(max-width:767px)').matches) {
			liveSearch.initMobile();
		} else {
			liveSearch.init();
		}
	});
};

app.fuelShop = function() {
	$('.toogle-visibility').on('change propertychange', function() {
		var target = $($(this).data('target'));

		if($(this)[0].checked) {
			target.removeClass('hidden');
		} else {
			target.addClass('hidden');
		}
	});

	$('#fuel-order-form-has-delivery, #fuel-order-form-has-account').on('change', function() {

		var form = $(this).closest('form');
		var target = $($(this).data('target'));

		form.parsley().destroy();

		var formElements = target.find('input,select');
		if($(this)[0].checked) {
			formElements.attr('data-parsley-required', 'true');
		} else {
			formElements.attr('data-parsley-required', 'false');
		}

		form.parsley();
	});

	$('#fuel-order-form-has-account').on('change', function() {

		var select = $('#fuel-order-form-paymentOption');
		var options = select.find('option[data-disable-without-account="true"]');

		if($(this)[0].checked) {
			options.removeAttr('disabled');
		} else {
			options.attr('disabled', true);
			var selectedOption = select.find('option:selected');
			if(selectedOption && selectedOption.data('disable-without-account') == true) {
				select.val('');
			}
		}

	});

	$('.js-fuel-input').bind('input propertychange change', function() {
		var form = $(this).closest('form');
		var priceWrapper = form.find('.js-price-wrapper');

		form.parsley().validate();

		$.ajax({
			url: '/brenn/calculate-price',
			method: 'post',
			data: form.serialize()

		}).done(function (result) {
			if(result.success) {
				priceWrapper.html(result.price);
			} else {
				//not valid
				priceWrapper.html(result.message);
			}

		}).error(function() {
			priceWrapper.html('');
		});
	});
};

app.massivhausTeaser = function() {

	$('.massivhaus--item').each(function() {
		var item = $(this);
		item.find('.change--massivhaus-image').on('click', function() {
			var id = $(this).data('id');

			var massivhausWrapper = item.find('.massivhaus--image-wrapper');

			massivhausWrapper.find('.massivhaus-image').addClass('hidden');
			massivhausWrapper.find("[data-placeholder-id='"+ id +"']").removeClass('hidden');

			$(this).addClass('active');
		});
	});

	$('.change-house').on('click', function() {
		var id = $(this).data('house-id');

		$(".house-wrapper").addClass('hidden');
		$("[data-house-id='"+ id +"']").removeClass('hidden');

	});
};


app.suppliersPlatform = function() {
	$.getScript("/static/js/libs/suppliers-platform.js").done(function () {
		suppliersPlatform.init();
	});
};

app.suppliersAdditionalUpload = function() {
	$.getScript("/static/js/libs/suppliers-platform.js").done(function () {
		suppliersPlatform.initAdditionalFilesUpload();
	});
};

app.growableTextArea = function() {
	$.getScript("/static/js/libs/autosize.min.js").done(function () {
		autosize($('.growableTextArea'));
	});
};

app.masonry = function() {
	if (matchMedia('(max-width: 767px)').matches) {
		return;
	}
	$.getScript("/static/js/libs/masonry.pkgd.min.js").done(function () {
		var container = $('.masonry-container');
		
		container.masonry({
			itemSelector        : '.masonry-item',
			columnWidth         : '.masonry-item',
			transitionDuration  : 0
		});
	});

};

app.modules.rangeSliderPlain = function() {
	$.loadScript('/static/js/libs/nouislider.min.js').done(function () {

		$('.js-filter-range-slider').each(function (key, value) {

			var id = $(this).prop('id');
			var inputIdFrom = $(this).data('input-from');
			var inputIdTo = $(this).data('input-to');

			var form = $(this).closest('form');

			var inputFrom = $('#'+inputIdFrom);
			var inputTo = $('#'+inputIdTo);

			var sliderName = $(this).data('slider-name');
			var displayFrom = $('#range-input-from-' + sliderName);
			var displayTo = $('#range-input-to-' + sliderName);

			/*var rangeTimout;*/
			var rangeSlider =  document.getElementById(id);
			var rangeMin = rangeSlider.dataset.minvalue;
			var rangeMax = rangeSlider.dataset.maxvalue;
			var rangeSelectedStart = rangeSlider.dataset.selectedvalue_start;
			var rangeSelectedEnd = rangeSlider.dataset.selectedvalue_end;

			rangeSelectedStart == undefined || rangeSelectedStart == '' ?  rangeSelectedStart = rangeMin : '';
			rangeSelectedEnd == undefined  || rangeSelectedEnd == '' ?  rangeSelectedEnd = rangeMax : '';


			/* destroy if already exists */
			if(rangeSlider.noUiSlider){
				rangeSlider.noUiSlider.destroy();
			}

			noUiSlider.create(rangeSlider, {
				start: [ rangeSelectedStart, rangeSelectedEnd ],
				range: {
					'min': parseInt(rangeMin),
					'max': parseInt(rangeMax)
				}
			});

			rangeSlider.noUiSlider.on('change', function(){

				var setRanges = rangeSlider.noUiSlider.get();
				var setRangesFrom = parseInt(setRanges[0]);
				var setRangesTo = parseInt(setRanges[1]);

				inputFrom.val(setRangesFrom);
				inputTo.val(setRangesTo);

				displayFrom.html(setRangesFrom);
				displayTo.html(setRangesTo);

				form.trigger('change');
			});


		});
	});
};

app.scaleYTVideos = function() {
	// Find all YouTube videos
	var $allVideos = $("iframe[src^='https://www.youtube.com']");

	console.log($allVideos);
	// The element that is fluid width
	var $fluidEl = $("#main");

	// Figure out and save aspect ratio for each video
	$allVideos.each(function() {

		$(this)
			.data('aspectRatio', this.height / this.width)
			.data('originalWidth', this.width)
			.data('originalHeight', this.height)

			// and remove the hard coded width/height
			.removeAttr('height')
			.removeAttr('width');

	});

	// When the window is resized
	$(window).resize(function() {

		var newWidth = $fluidEl.width();

		// Resize all videos according to their own aspect ratio
		$allVideos.each(function() {
			var $el = $(this);

			if($el.is(":visible")) {
                if (newWidth < $el.data('originalWidth')) {
                    $el.width(newWidth).height(newWidth * $el.data('aspectRatio'));
                } else {
                    $el.width($el.data('originalWidth')).height($el.data('originalHeight'));
                }
            }
		});

	// Kick off one resize to fix all videos on page load
	}).resize();
};

app.scrollToTabElement = function() {

	$('.js-scroll-to-tab-element').on('click', function(evt) {
		evt.preventDefault();

		var tabNavElement = $($(this).data('tab-collapse'));
		var scrollTarget = $($(this).data('scroll-target'));

		
		if (tabNavElement.hasClass('js-tabs-collapse') && matchMedia('(max-width: 767px)').matches) {
		//	tabs with .js-tabs-collapse have a different behavior on mobile -> are collapsibles
            var scrollTarget = $('#' + scrollTarget.attr('id') + '-collapse');
            scrollTarget.collapse('show');

			$('html, body').stop().animate({
				scrollTop: scrollTarget.offset().top - 50
			} ,500);

        } else {
			var navItem = tabNavElement.find('a[href="#'+ scrollTarget.attr('id') + '"]');
			navItem.tab('show');

            $('html, body').stop().animate({
                scrollTop: scrollTarget.offset().top - 200
            } ,500);
        }
        


	});
};

app.scrollTop = function() {
	$('#btn-scrollTop').on('click', function(evt) {
		evt.preventDefault();
		$('html, body').stop().animate({
			scrollTop:0
		} ,500);
	});
};

app.scrollToElementOnInit = function() {
    var $target = $(_config.scrollToElementOnInit);

    $( window ).load(function() {

        app.modules.scrollTo.scrollToEl($target);
    });

};

app.bauproduktenverordnung = function() {
	var form = $('.bauproduktenverordnung-form');

	var companySelect = form.find('.js-company-search');
	var groupSelect = form.find('.js-group-search');
	var productGroupSelect = form.find('.js-productGroup-search');

	var eanTextField = form.find('.js-ean-search-text');

	var resultTable = form.find('.js-result-table');

	var doRequest = function(service, params, callback) {
		form.addClass('is-loading');
		$.ajax({
			url: '/bauproduktenverordnung/' + service,
			type: 'get',
			data: params
		}).done(function(result){
			form.removeClass('is-loading');
			callback(result);
		});
	};

	companySelect.on('change', function() {
		var companyId = $(this).val();
		groupSelect.find('option:gt(0)').remove();
		productGroupSelect.find('option:gt(0)').remove();
		resultTable.addClass('hidden');

		doRequest('groups', {'companyId': companyId}, function(result) {
			if(result && result != 'error') {
				$.each(result, function(index, item) {
					groupSelect.append($('<option>', {value: item.id}).text(item.name));
				});
			}
		});
	});

	groupSelect.on('change', function() {
		var companyId = companySelect.val();
		var groupId = $(this).val();
		productGroupSelect.find('option:gt(0)').remove();
		resultTable.addClass('hidden');

		doRequest('product-groups', {'companyId': companyId, 'groupId': groupId}, function(result) {
			if(result && result != 'error') {
				$.each(result, function(index, item) {
					productGroupSelect.append($('<option>', {value: item.id}).text(item.name));
				});
			}
		});
	});

	productGroupSelect.on('change', function() {
		var companyId = companySelect.val();
		var groupId = groupSelect.val();
		var productGroupId = productGroupSelect.val();
		resultTable.addClass('hidden');

		doRequest('products-table', {'companyId': companyId, 'groupId': groupId, 'productGroupId' : productGroupId}, function(result) {
			resultTable.html(result);
			resultTable.removeClass('hidden');

			$('html, body').stop().animate({
				scrollTop: resultTable.offset().top - 100
			} ,500);
		});
	});

	form.on('submit', function(ev) {
		ev.preventDefault();

		var ean = eanTextField.val();

		groupSelect.find('option:gt(0)').remove();
		productGroupSelect.find('option:gt(0)').remove();
		companySelect.val(companySelect.find("option:first").val());
		resultTable.addClass('hidden');
		doRequest('ean', {'ean': ean}, function(result) {
			resultTable.html(result);
			resultTable.removeClass('hidden');

			$('html, body').stop().animate({
				scrollTop: resultTable.offset().top - 100
			} ,500);
		});
	});

};


app.modules.fourXFourInput = function($scope) {

	$.getScript("/static/js/libs/jquery.inputmask.bundle.min.js").done(function () {
        $scope.find('.js-four-x-four-input').inputmask('****-****-****-****', {
            'placeholder': '    -    -    -    ',
			'removeMaskOnSubmit': true
        });
    });
};

app.keepSessionAlive = function() {
	setInterval(function() {
		$.get('/ping');
		console.log('ping');
	}, 60 * 1000);
};

app.modules.jsGotoSelect = function($scope) {
    $scope.find('.js-goto-select').on('change', function() {
		window.location.href = $(this).val();
	});
};

app.modules.variantGroupSelect = function($scope) {

	var variantSelects = $scope.find('.js-variant-select');
    variantSelects.on('change', function() {
        var idsArray = [];
    	variantSelects.each(function() {
            idsArray.push(JSON.parse($(this).val()));
		});

    	var changedValues = JSON.parse($(this).val());

    	var modalReplace = $(this).hasClass('js-variant-modal-replace');
    	if(modalReplace) {
            $('.js-modal-replace').addClass('is-loading');
            $.ajax({
                url: '/find-matching-variant',
                method: 'post',
                data: {
                    'variantIds': idsArray,
                    'grouperCount': variantSelects.length,
                    'changedValues': changedValues
                }
            }).done(function (data) {
                if (data.success) {

                	$.ajax({
						url: '/warenkorb/add-to-cart-modal',
                        dataType: 'html',
						data: {
							'id': data.productId
						}
					}).done(function (data) {
                        $('.js-modal-replace').replaceWith(data);
                        app.initModules($('.js-modal-replace'));
                    });
                }
            });
        } else {
            $.ajax({
                url: '/find-matching-variant',
                method: 'post',
                data: {
                    'variantIds': idsArray,
                    'grouperCount': variantSelects.length,
                    'changedValues': changedValues
                }
            }).done(function (data) {
                if (data.success) {
                    window.location.href = data.url;
                } else {
                    console.log('no variant found');
                }
            });
		}
	})
};

app.modules.reloadAddToCart = function($scope) {
    $scope.find('.js-reload-add-to-cart').on('change', function() {
		var quantity = $(this).val();
		var productId = $(this).data('product-id');

		var $outerContainer = $(this).closest('.js-reload-add-to-cart-container');
		var container = $('.product-detail__cart');

        container.addClass('is-loading');
        $.ajax({
            url: '/reload-cart',
            method : 'get',
			data: {
				'product-id': productId,
				'quantity': quantity
            }
		}).done(function (data) {
            container.replaceWith(data);
            app.initModules($outerContainer);
        });
	});

    $scope.find('form.form--prod-detail-cart').on('submit', function(e) {
        e.preventDefault();
    });

    $scope.find('.js-reload-add-to-cart-checkbox').on('change', function() {

        var $cartContainer = $('.js-reload-add-to-cart-container');
        if($cartContainer.length != 0) {
            var productId = $cartContainer.find('.product-detail__cart').data('product-id'),
                container = $cartContainer.find('.product-detail__cart'),
                quantity = $cartContainer.find('.js-number-spinner__input').val();
        }

        var checkbox = $(this);
        var updateLocationDropdownMetaInfo = function(el) {
            var locName = el.data('name');
            var locOpeningHours = el.data('opening-hours');
            var locPhone = el.data('phone');
            var locPhoneShort = el.data('phone-short');
            var colorCode = el.data('location-isopen') ? 'color-green' : 'color-red';

            $('.js-toggle-dropdown').removeClass('is-open').children('.js-toggle-dropdown__text').html(locName);
            if(el.data('location-state')) {
                el.closest('.location-wrapper').find('.js-toggle-dropdown__text').append(el.data('location-state'));
            }
            $('#meta--openingHours').html('<span class="icon icon-clock '+ colorCode +'"></span><span class="oh-string animated-03 fadeInDown inline-block">' + locOpeningHours + '</span>');
            $('#meta--phoneNumber').html('<span class="icon icon-telefon"></span><a href="tel:' + locPhone + '" role="tel" class="animated-05 fadeInDown inline-block">' + locPhoneShort + '</a>');

        };


        $.ajax({
            url: '/warenkorb/change-location',
            data: {
                'location-id': $(this).val()
            }
        }).done(function (result) {
            updateLocationDropdownMetaInfo(checkbox);
            if($('.js-reload-add-to-cart-container').length != 0) {
                $.ajax({
                    url: '/reload-cart',
                    method : 'get',
                    data: {
                        'product-id': productId,
                        'quantity': quantity
                    }
                }).done(function (data) {
                    container.replaceWith(data);
                    app.initModules($cartContainer);
                });
            }

            var modalReplace = checkbox.hasClass('js-variant-modal-replace');
            if(modalReplace) {
                var pId = checkbox.data('product-id');
                $('.js-modal-replace').addClass('is-loading');
                $.ajax({
                    url: '/warenkorb/add-to-cart-modal',
                    dataType: 'html',
                    data: {
                        'id': pId
                    }
                }).done(function (data) {
                    $('.js-modal-replace').replaceWith(data);
                    app.initModules($('.js-modal-replace'));
                });
            }
        });

	});
};

app.modules.uniqueCheckbox = function($scope) {

	var checkboxes = $scope.find('.js-unique-checkbox');

	checkboxes.on('change', function() {

		var currentCheckbox = $(this);
        if(currentCheckbox[0].checked) {

            checkboxes.each(function() {
            	$(this).prop('checked', false);
			});

            currentCheckbox.prop('checked', true);
		}
	});
};

app.modules.cartForm = function ($scope) {
	var $input = $scope.find('.js-cart-form__input');

	$input.on('change', function () {
        var $form = $(this).closest('.js-cart-form'),
			formData = $form.serialize(),
			includeContainer = $form.data('target');

        $form.addClass('is-loading');

        $.ajax({
            url: $form.data('action'),
			method: $form.prop('method'),
			data: formData
        }).done(function (response) {
            $(includeContainer).replaceWith(response);
            app.initModules($(includeContainer));

            $('.update-nr').each(function () {
            	var $this = $(this);
                $.ajax({
                    url: $this.data('update-url')
                }).done(function (response) {
                    $this.html(response);
                });
            });

            $form.removeClass('is-loading');
        });
    });
};

// copies the  value of an input (data-synced-input of master) to the master-input (.js-synced-input)
app.modules.syncInputs = function ($scope) {
    var selector = '.js-synced-input';
    $scope.find(selector).each(function () {
		var $master = $(this);
		var $linkedInput = $($master.data('synced-input'));
		
        $linkedInput.each(function () {
			var $thisInput = $(this);
			var parsleyListenerSet;

			// if linked input is not empty on init (except select-field), don't change
			if ($thisInput.prop('type') != 'select-one' && $thisInput.val()){
				return true;
			}

			$master.on('input',function () {
				// set a listener that validates the synced input
                if (!parsleyListenerSet) {
                    if ($master.data('Parsley')) {
                        $master.parsley().on('field:validated', function () {
                            if ($thisInput.data('Parsley')) {
                                $thisInput.data('Parsley').validate();
                            }
                        });
                        parsleyListenerSet = true;
                    }
                }

				// only sync as long as the synced input group has not been changed
				if (!$thisInput.closest('.form-group').data('dont-change')) {
					// only sync as long as the synced input has not been changed
					if (!$thisInput.data('dont-change')) {
						$thisInput.val($master.val());
					}
				}
			});

            $thisInput.on('input', function () {
				// stop master from syncing
				$(this).data('dont-change', true);
				$(this).closest('.form-group').data('dont-change', true);
			})
		});

	}
	);
};


app.modules.dobInput = function($scope) {

	$scope.find('.js-dob-input').each(function () {

		var inputName = $(this).data('input-name');

		var dayInput = $(this).find("#" + inputName + "\\[day\\]");
		var monthInput = $(this).find("#" + inputName + "\\[month\\]");
		var yearInput = $(this).find("#" + inputName + "\\[year\\]");

		var daysInMonth = function(month, year) {
            return new Date(year, month, 0).getDate();
        };

		var updateDays = function() {

            var selectedDay = dayInput.val();
            var selectedMonth = monthInput.val();
			var selectedYear = yearInput.val();

			if(selectedDay && selectedMonth && selectedYear) {
                var days = daysInMonth(selectedMonth, selectedYear);

                dayInput.html('');
                for (i = 1; i <= days; i++) {
                    val = i;
                    if (val <= 9) {
                        val = '0' + val;
                    }
                    dayInput.append($('<option />').val(i).html(val));
                }

                dayInput.val(selectedDay);
            }
		};

        monthInput.on('change', function () {
            updateDays();
        });
        yearInput.on('change', function () {
            updateDays();
        });
    });
};

app.radioToggleVisibility = function() {
    var emailInput = $('#wrapper-contact-info-per-m');
    var smsInput = $('#wrapper-contact-info-per-s');
    var telInput = $('#wrapper-contact-info-per-a');

    $('.toggle-visibility').on('change propertychange', function() {

        var form = $(this).closest('form');
        form.parsley().destroy();

        emailInput.addClass('hidden');
        smsInput.addClass('hidden');
        telInput.addClass('hidden');

        emailInput.find('input, select').attr('data-parsley-required', 'false');
        smsInput.find('input, select').attr('data-parsley-required', 'false');
        telInput.find('input, select').attr('data-parsley-required', 'false');


        telInput.find('*[id*=vorwahl]').removeAttr('data-parsley-type');
        telInput.find('*[id*=nummer]').removeAttr('data-parsley-pattern');


        var target = $($(this).data('target'));
        if($(this)[0].checked) {
            var elements = target.find('input, select');
            target.removeClass('hidden');
            elements.attr('data-parsley-required', 'true');

            if(target.prop('id') === telInput.prop('id')) {
                telInput.find('*[id*=vorwahl]').attr('data-parsley-type', 'digits');
            	telInput.find('*[id*=nummer]').attr('data-parsley-pattern', '^[0-9]+[0-9|\\-]{1}[0-9]+$');
            }
		}
        form.parsley();
        app.modules.parsley(form.parent());
    });
};

app.modules.showIfChecked = function($scope) {
    // shows and hides the element in 'data-show-if-checked' on change
    var $inputs = $scope.find('.js-show-if-checked');
    $inputs.on('change', changeHandler);

    // check for other radios without the show-if-checked-class to fire the change event (close other elements)
    $inputs.each(function () {
        var $this = $(this);

        if($this.is(':radio')){
            var $otherRadios = $('input[name="' + $this.attr('name') + '"]').not($this).not('.js-show-if-checked');

            $otherRadios.on('change', changeHandler);
        }
    });

    function changeHandler(evt) {
        var $this = $(this);

        // this part processes all other inputs. So the ones that get automatically unchecked (by the browser) close their targetEl
        if($this.is(':radio')){
            var $otherRadios = $('input[name="' + $this.attr('name') + '"]').not($this);
            $otherRadios.each(function () {
                processInput($(this));
            });
        }

        processInput($this);

    }

    function processInput($input) {
        var $toggleEl = $($input.data('show-if-checked'));

        if ($input.is(':checked')) {
            $toggleEl.attr('hidden', null);
        } else {
            $toggleEl.attr('hidden', 'hidden');
        }
    }
};

app.modules.initScalePricesPopover = function($scope) {
    // $scope.find('.js-scale-prices-popover').popover('destroy');
    $('body').off('click.scales-prices-popover');

    $scope.find('.js-scale-prices-popover').popover({
        template: '<div class="popover--small popover--green" role="tooltip"><div class="arrow"></div><h3 class="popover-title popover--small-title"></h3><div class="popover-content popover--small-content"></div></div>'
    }).popover('show');
    $('body').on('click.scales-prices-popover', function (e) {
        //did not click the popover
        if ($(e.target).parents('.popover--small.in').length === 0) {
            $('.js-scale-prices-popover').popover('hide');
            $('body').off('click.scales-prices-popover');
        }
    });
};

app.modules.removeSpecialCharacter = function ($scope) {
    $scope.find('.js-remove-special-character').on('click', function () {
        var inputs = $(this).closest('form').find('.js-remove-special-character__input');

        inputs.each(function () {
            var val = $(this).val();
            val = val.replace(/[^0-9]/g, '');
            $(this).val(val);
        })
    });
};

app.modules.machinesFilterGrid = function($scope) {
    $('.js-reset-filter').on('click', function() {
        $('.js-machine-filter').addClass('is-loading');
        $('.js-machine-grid').addClass('is-loading');
    });

    var filterWrapper = $scope.find('.js-machine-filter');
    var gridWrapper = $scope.find('.js-machine-grid');

    filterWrapper.find('#input-current-value-from, #input-current-value-to').on('change', function (e) {
		console.log(e);
    });

    filterWrapper.find('form').on('change', function(e) {
        filterWrapper.addClass('is-loading');
        gridWrapper.addClass('is-loading');

        //console.log($(this).serialize());

        $.ajax({
            method: 'get',
            data: $(this).serialize()
        }).success(function (response) {

            filterWrapper.html($(response).find('.js-machine-filter'));
            gridWrapper.html($(response).find('.js-machine-grid'));

            filterWrapper.removeClass('is-loading');
            gridWrapper.removeClass('is-loading');

            app.initModules();
        });
    });

};

app.modules.searchForCloseLocations = function($scope) {

    $scope.find('#search-locations').on('input', function() {
        var searchBtn = $('#search-location-submit-btn');
        var findAllBtn = $('#search-location-show-all');


        if($(this).val() != '') {
            searchBtn.removeClass('hidden');
            findAllBtn.addClass('hidden');
        } else {
            searchBtn.addClass('hidden');
            findAllBtn.removeClass('hidden');
        }
    });



	$scope.find('.form-location-search').on('submit', function(evt) {
        evt.preventDefault();

        var loadingSection = $(this).closest('.content-section');
        loadingSection.addClass('is-loading');
        var q = $(this).find('#search-locations').val();
        $.ajax({
            url: '/standorte/action/search-for-close-locations',
            data: {
                'q': q,
				'type': $(this).data('teaser-type')
            }
        }).done(function (result) {
            var resultContainer = $('.location-finder-results');
            var noResultText = resultContainer.data('no-results-text');
			if(result == '') {
                resultContainer.html('<div class="col col-xs-12 no-stores fz20"><div class="alert alert-warning">' +
                    '<span class="icon icon-attention"></span>&nbsp;' + noResultText +'</div></div> ');
            } else {
                resultContainer.html(result);
                app.initModules(resultContainer);
            }
        }).always(function() {
            loadingSection.removeClass('is-loading');
        });
    });
};

app.modules.autoSubmit = function($scope) {
    $scope.find('form.js-auto-submit').on('change', function (e) {
        $(this).submit();
    });
};

app.modules.loadRechnungen = function ($scope) {
    var rechnungsCollapse = $scope.find('.js-load-rechnungen');

    if(rechnungsCollapse && rechnungsCollapse.length) {
        rechnungsCollapse.on('show.bs.collapse', function(evt) {
            var yearPanel = $(this);
            if(yearPanel.data('is-loaded') == false) {
                var url = yearPanel.data('load-url');
                var target = $(yearPanel.data('target'));

                $.ajax({
                    url: url,
                    cache: true
                }).done(function(result) {
                    target.html(result);
                    yearPanel.data('is-loaded', true);
                });
            }
        });
    }
};




app.easterEgg = function() {
    var kkeys = [], konami = "38,38,40,40,37,39,37,39,66,65";

    $(document).keydown(function(e) {
        kkeys.push( e.keyCode );
        if ( kkeys.toString().indexOf( konami ) >= 0 ) {
            $(document).unbind('keydown',arguments.callee);
            $("body").css("-webkit-filter", "invert(100%)");
            $("body").css("filter", "invert(100%)");
        }
    });
};

app.ecommerceDataLayerFunnel = function () {
    $.loadScript('/static/js/seo/ecommerceDataLayerFunnel.js').done(function () {
        ecommerceDataLayerFunnel.init();
    });
};

app.modules.tracking  = function($scope) {
    $scope.find('.js-gtm-nav-link').on('click', function() {
        var label = $(this).data('gtm-nav-link-text'),
            action = $(this).closest('.js-gtm-nav-link-parent').children('.js-gtm-nav-link-parent__link').data('gtm-nav-link-text');

        dataLayer.push({
            'event': 'genericGtmEvent',
            'genericEventCategory': 'Navigation',
            'genericEventAction': action,
            'genericEventLabel': label,
            'genericEventValue': ''
        });
    });

    $scope.find('.js-track-details-btn').on('click', function() {
        dataLayer.push({'event': 'gridDetailsBtnClick'});
    });
};

app.modules.hobexPayment = function($scope) {

    if(_config.hobexPaymentData.scriptUrl) {
        $.getScript(_config.hobexPaymentData.scriptUrl).done(function () {
            wpwlOptions = $.extend(wpwlOptions, {
                onReady: function() {
                    $('.wpwl-container').each(function () {
                        var id = $(this).attr("id");
                        var paymentType = id.substring(0, id.lastIndexOf("_"));
                        // render template and fill with data (set correct ids, and title)
                        var $el = $(tmpl('js-hobex-template', {
                            data: {
                                idSuffix: id,
                                headingTitle:  _config.hobexPaymentData.translations[paymentType]
                            }
                        }));
                        // insert the rendered template before the widget
                        $el.insertBefore($(this));

                        // todo: change to directdebit
                        if (paymentType == 'directDebit') {
                            var $message = $el.find('.js-hobex-payment__message');
                            var $panelBody = $el.find('.js-hobex-payment__panel-body');
                            $message.attr('hidden', false);
                            $panelBody.attr('hidden', true);

                            $el.find('.js-hobex-payment__accept-message').on('click', function () {
                                $message.attr('hidden', true);
                                $panelBody.attr('hidden', false);
                            })
                        }
                        // put widget into the collapse-body
                        $(this).appendTo($el.find('.js-hobex-payment__panel-body'));

                    });
                }
            })
        });
    }
};

app.modules.googleRecaptcha = function ($scope) {
	console.log("googleRecaptcha Init");
	function getReCaptcha(){
		grecaptcha.ready(function() {
			// do request for recaptcha token
			// response is promise with passed token
			grecaptcha.execute(_config.googleRecaptchasiteKey, {action:'homepage'})
				.then(function(token) {
					// add token value to form
					document.getElementById(_config.googleRecaptchaField).value = token;
				});
		});
	}

	getReCaptcha();  // This is the initial call
	setInterval(function(){getReCaptcha();}, 100000);
};

// Simple JavaScript Templating
// John Resig - https://johnresig.com/ - MIT Licensed
(function(){
    var cache = {};

    this.tmpl = function tmpl(str, data){
        // Figure out if we're getting a template, or if we need to
        // load the template - and be sure to cache the result.

        var fn = !/[^a-zA-Z0-9_-]/.test(str) ?
            cache[str] = cache[str] ||
                tmpl(document.getElementById(str).innerHTML) :

            // Generate a reusable function that will serve as a template
            // generator (and which will be cached).
            new Function("obj",
                "var p=[],print=function(){p.push.apply(p,arguments);};" +

                // Introduce the data as local variables using with(){}
                "with(obj){p.push('" +

                // Convert the template into pure JavaScript
                str
                    .replace(/[\r\t\n]/g, " ")
                    .split("<%").join("\t")
                    .replace(/((^|%>)[^\t]*)'/g, "$1\r")
                    .replace(/\t=(.*?)%>/g, "',$1,'")
                    .split("\t").join("');")
                    .split("%>").join("p.push('")
                    .split("\r").join("\\'")
                + "');}return p.join('');");

        // Provide some basic currying to the user
        return data ? fn( data ) : fn;
    };
})();


app.initModules = function ($scope) {

	if(!$scope) {
		$scope = $('body');
	}

	//init all modules if the right _cfg key is set for them
	for (var module in _cfg) {
		if (_cfg[module] && app.modules[module] && typeof  app.modules[module] === 'function') {
			app.modules[module]($scope);
		}
	}
};

app.init = function () {

	$.ajaxSetup({
		cache: true
	});

	app.initModules();

	for (var module in _cfg) {
		if (app[module] && typeof  app[module] === 'function') {
			app[module]();
		}
	}

};

app.init();